import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { InvitationService } from './invitation.service';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class InviteActionService {
  constructor(
    private invitationService: InvitationService,
    private userService: UserService
  ) {}

  handleInviteAction(type: string, id: string, action: string, groupId?: string): Observable<any> {
    return this.userService.getUser().pipe(
      switchMap(user => {
        if (!user) return throwError(() => new Error('User not logged in'));
        
        if (action === 'accept') {
          return this.invitationService.acceptInvitationById(id, {}).pipe(
            map(result => ({ success: true, message: 'Invitation accepted', result }))
          );
        } else if (action === 'decline') {
          return this.invitationService.cancelInvitation(id).pipe(
            map(result => ({ success: true, message: 'Invitation declined', result }))
          );
        }
        
        return throwError(() => new Error('Unknown action: ' + action));
      })
    );
  }
} 